<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">GF General Setting<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / GF Process Settings / GF General Setting</span>
        </h4>

        <div class="ibox mt-4">
            <div class="ibox-content">

                <form enctype="multipart/form-data" @submit.stop.prevent="formSubmit">
                    <div v-if="$acl['company/savegfsettings'] > 0" id="gf_general_settings">

                        <div class="clearfix row no-margin">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            GF General Settings
                                        </div>
                                        <div class="approve-level-description">
                                            The GF Settings allow you to configure multiple functions of the Gratuity module, including eligibility rules, calculation methods, service period requirements, fiscal year settings, and audit features.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        <div class="clearfix px-0">
                                            <div class="clearfix">

                                                <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin">
                                                    <div class="col-md-9 px-0 salary-heads">Enable Gratuity Fund <b-icon icon="info-circle" title="Enable Gratuity Fund" v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right">
                                                        <toggle-button v-model="fdata.enable_gratuity_fund" key="enable_gratuity_fund" value="true" :sync="true" :color="{checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                                                    </div>
                                                </div>

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin form-group px-4">
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <b-form-group id="gf_financial_year_end_month-group" label="GF Financial Year End Month" label-for="gf_financial_year_end_month" class="required-field">
                                                            <b-form-select name="gf_financial_year_end_month" class="form-control" v-model="fdata.gf_financial_year_end_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('gf_financial_year_end_month')" aria-describedby="gf_financial_year_end_month-feedback" data-vv-as="Status">
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="gf_financial_year_end_month-feedback">{{ veeErrors.first('gf_financial_year_end_month') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="clearfix rounded px-0 service_length_settings mt-3">

                                                <div class="pb-3 row">
                                                    <div class="col-md-6">
                                                        <p class="service_length_title salary-heads">Service length format settings <b-icon class="" icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>
                                                        <div class="mt-3">
                                                            <div class="toggle_button_tax first salary-heads d-flex"  >
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Years and Months</div>
                                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                        <input data-v-25adc6c0="" type="radio" v-model="fdata.company_gf_service_month" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="yes"> 
                                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                                            <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                                                </div>
                                                                
                                                            </div>
                                                            
                                                            <div class="toggle_button_tax first salary-heads d-flex">
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Only Months</div>
                                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                        <input data-v-25adc6c0="" type="radio" v-model="fdata.company_gf_service_month" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="no" > 
                                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                                            <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                                                </div>
                                                                
                                                            </div>
                                                            
                                                        </div>
                                                    </div>                                                            

                                                    <div class="ibox no-shadow border-2 mt-4 gray-border col-md-6">
                                                        <b-overlay  rounded="sm"  class='payslip-designer-overlay'>
                                                            <div class="clearfix service_format_overview mb-3 mt-2 mx-auto px-3 py-4">
                                                                <div class ="number_format_header_title font-medium" style="font-size: 18px;color: #747474;">Sample Output</div>
                                                                <table style="width: 99%;" class="d-table">
                                                                
                                                                    <template v-if="fdata.company_gf_service_month=='no'">
                                                                        <tr> 
                                                                            <td class = 'service_format_overview_td_label py-2 text-secondary border-bottom' ><template >Service Period</template></td>  <td class = 'service_format_overview_td_value border-bottom py-2'><template >47 Month(s)</template></td>
                                                                        </tr> 
                                                                        <tr> 
                                                                            <td  class = 'service_format_overview_td_label text-secondary py-2'><template >Membership Period</template></td>  <td  class = 'service_format_overview_td_value py-2'  ><template >11 Month(s)</template></td>
                                                                        </tr> 
                                                                    </template>
                                                                    <template v-if="fdata.company_gf_service_month=='yes'">
                                                                        <tr> 
                                                                            <td  class = 'service_format_overview_td_label py-2 text-secondary border-bottom'><template >Service Period</template></td>  <td class = 'service_format_overview_td_value py-2 border-bottom'  ><template >3 Year(s) 11 Month(s)</template></td>
                                                                        </tr> 
                                                                        <tr> 
                                                                            <td  class = 'service_format_overview_td_label text-secondary py-2'><template >Membership Period</template></td>  <td class = 'service_format_overview_td_value py-2' ><template >0 Year(s) 11 Month(s)</template></td>
                                                                        </tr> 
                                                                    </template> 
                                                    
                                                                </table>   
                                                            </div>
                                                        </b-overlay>
                                                    </div>
                                                </div>

                                                <div class="row mx-1 mb-3 py-2 w-100 align-items-center no-margin border-bottom">
                                                    <div class="col-md-9 px-0 salary-heads">Migration Support <b-icon icon="info-circle" title="Enable Migration Support" v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right">
                                                        <toggle-button v-model="fdata.gf_migration_support" key="migration_support" value="true" :sync="true" :color="{checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                                                    </div>
                                                </div>

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin form-group px-0" v-if="fdata.gf_migration_support">
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <b-form-group id="gf_migration_month-group" label="Month" label-for="gf_migration_month" class="required-field">
                                                            <b-form-select name="gf_migration_month" class="form-control" v-model="fdata.gf_migration_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('gf_migration_month')" aria-describedby="gf_migration_month-feedback" data-vv-as="Status">
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="gf_migration_month-feedback">{{ veeErrors.first('gf_migration_month') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <b-form-group id="gf_migration_year-group" label="Year" label-for="gf_migration_year" class="required-field">
                                                            <b-form-select name="gf_migration_year" class="form-control" v-model="fdata.gf_migration_year" v-validate="{ required: true }" :state="validateState('gf_migration_year')" aria-describedby="gf_migration_year-feedback" data-vv-as="Status">
                                                                <option v-for="year in yearsList" :key="year" :value="year">{{ year }}</option>
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="gf_migration_year-feedback">{{ veeErrors.first('gf_migration_year') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>

                                                <!-- Investment Feature -->
                                                <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom" v-if="fdata.enable_gratuity_fund == true && addons.includes('GfInvestment')">
                                                    <div class="col-md-9 px-0 salary-heads">Gratutiy Fund Investment Feature
                                                        <b-icon class="" icon="info-circle" title="If enabled employees will be able to see the Gratuity Fun Investment Features" v-b-tooltip></b-icon>
                                                    </div>
                                                    <div class="col-md-3 text-right px-0">
                                                        <toggle-button v-model="fdata.gratuity_fund_investment_feature" key="gratuity_fund_investment_feature" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                    </div>
                                                </div> -->

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin">
                                                    <div class="col-sm-12 text-right">
                                                        <button type="submit" class="btn btn-primary btn-md">SAVE</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['companyid', 'pageurl'],

    data() {
        return {
            m_lists: [
                { value: '1', text: 'January' }, { value: '2', text: 'February' }, { value: '3', text: 'March' },
                { value: '4', text: 'April' }, { value: '5', text: 'May' }, { value: '6', text: 'June' },
                { value: '7', text: 'July' }, { value: '8', text: 'August' }, { value: '9', text: 'September' },
                { value: '10', text: 'October' }, { value: '11', text: 'November' }, { value: '12', text: 'December' },
            ],
            yearsList: [],
            company_id: this.companyid,

            fdata: {
                enable_gratuity_fund: true,
                gf_migration_support: true,
                gf_financial_year_end_month: 6,
                gf_migration_month: 1,
                gf_migration_year: new Date().getFullYear(),
                company_gf_service_month: 'no',
                // NOT edited on this tab. Kept in sync with the last-fetched value and
                // re-sent unchanged on save so this form doesn't wipe out whatever the
                // "GF Contribution Process Policy" tab has set. /gf/savegfsettings
                // currently expects all GF fields together in one payload — see
                // formSubmit() below.
                gf_contribution_policy: 1,
                // gratuity_fund_investment_feature: false,
            },
            addons: [],
        };
    },

    methods: {
        generateYears() {
            const startYear = 2001;
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let year = currentYear; year >= startYear; year--) {
                years.push(year);
            }
            return years;
        },

        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        getCompanyGFSettings() {
            let formData = new FormData();
            axios.post(this.$api_url + '/gf/companygfsettings', formData)
                .then((response) => {
                    if (response.data.data) {
                        const s = response.data.data;

                        this.fdata.gf_financial_year_end_month =
                            (s.gf_year_end.opt_value == 0 || s.gf_year_end.opt_value == 'null')
                                ? 6
                                : s.gf_year_end.opt_value;

                        this.fdata.company_gf_service_month =
                            parseInt(s.gf_service_month_format.opt_value) == 1 ? 'yes' : 'no';

                        this.fdata.enable_gratuity_fund = s.gf_enabled.opt_value == 'true';
                        this.fdata.gf_migration_support = s.gf_migration_support.opt_value == 'true';
                        this.fdata.gf_migration_month = parseInt(s.gf_migration_month.opt_value);
                        this.fdata.gf_migration_year = parseInt(s.gf_migration_year.opt_value);

                        this.fdata.gf_contribution_policy =
                            (s.gf_contribution_policy.opt_value == 0 || s.gf_contribution_policy.opt_value == 'null')
                                ? 1
                                : s.gf_contribution_policy.opt_value;
                        // this.fdata.gratuity_fund_investment_feature = parseInt(s.gratuity_fund_investment_feature.opt_value) === 1;
                    }
                });
        },

        formSubmit(e) {
            e.preventDefault();

            let currentObj = this;
            let formData = new FormData();
            const config = { headers: { 'content-type': 'multipart/form-data' } };

            let gf_service_month_format = (this.fdata.company_gf_service_month == 'no') ? 0 : 1;

            // formData.append('company_id', this.company_id);
            formData.append('company_gf_status', this.fdata.enable_gratuity_fund);
            formData.append('gf_migration_support', this.fdata.gf_migration_support);
            formData.append('gf_financial_year_end_month', this.fdata.gf_financial_year_end_month);
            formData.append('gf_service_month_format', gf_service_month_format);
            formData.append('gf_migration_month', this.fdata.gf_migration_month);
            formData.append('gf_migration_year', this.fdata.gf_migration_year);
            // formData.append('gratuity_fund_investment_feature', this.fdata.gratuity_fund_investment_feature ? 1 : 0);
            // Re-send the last-fetched Contribution Policy value untouched
            // on fdata.gf_contribution_policy above.
            formData.append('gf_contribution_policy', this.fdata.gf_contribution_policy);

            axios.post(this.$api_url + '/gf/savegfsettings', formData, config)
                .then((response) => {
                    if (response.data.data) {
                        this.getCompanyGFSettings();
                        this.$bvToast.toast('GF Settings saved', { title: 'Success', variant: 'success', solid: true });
                    } else {
                        this.$bvToast.toast('An error occurred, please try again later', { title: 'Error!', variant: 'danger', solid: true });
                    }
                })
                .catch((error) => {
                    currentObj.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true });
                });
        },

        getcompany() {
            let formData = new FormData();
            axios.post(this.$api_url + '/company/getcompany', formData)
                .then((response) => {
                    this.company_id = response.data;
                    if (this.company_id > 0) {
                        this.getCompanyGFSettings();
                    }
                });
        },
        getCompanyData() {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/details').then(response => {
                if (response.data.length != 0) {
                    this.addons  = response.data.module_disabled;
                }
            });
        },
    },

    created() {
        this.yearsList = this.generateYears();
        this.getcompany();
        this.getCompanyData();
    },
};
</script>

<style scoped>
.trz_service_button {
    display: inline-block;
    vertical-align: top;
    padding-left: 0;
}
.service_length_title[data-v-83ba1f78] {
    margin-top: 33px;
    margin-bottom: 10px;
}
.trz_service_button .v-switch-button {
    transform: translate3d(3px, 3px, 0px);
    width: 16px;
    height: 16px;
    transition: transform 300ms ease 0s;
}
.toggle_button_tax {
    margin-bottom: 10px;
}
.service_length_settings .toggle_button_tax {
    padding: 10px 0 10px 0;
    margin: 0;
}
.toggle_button_tax.first {
    border-bottom: 1px solid #dee2e6;
}
.trz_service_button.tax_toggle {
    float: right;
}
.trz_service_button.px-0.tax_toggle {
    max-width: 50px;
}
.service_format_overview {
    margin-top: 35px;
    margin-left: 15px !important;
    padding: 10px 10px !important;
}
.service_format_overview_td_label {
    text-align: left !important;
    font-size: 16px !important;
    width: 45% !important;
}
.service_format_overview_td_value {
    text-align: right !important;
    font-size: 16px !important;
    width: 65% !important;
    color: #004242;
}
.number_format_header_title {
    text-align: center;
    margin-bottom: 10px;
}
</style>